/**
 * L-NAV-8 — l'ACCUEIL de chaque rôle, en un seul endroit.
 *
 * Décision UX D-1 (inchangée pour l'agent) : l'AGENT atterrit sur son OUTIL,
 * le téléphone (`/v2/softphone`) — à condition d'avoir la permission d'appeler,
 * sinon sur « Mon activité » (`/analytics`). L-NAV-8 : l'ADMIN (super-admin
 * compris : c'est un ADMIN du tenant Système) atterrit sur « Aujourd'hui »
 * (`/accueil`), qui remplace `/supervision`. Les autres rôles gardent
 * `/analytics`.
 *
 * Deux lecteurs : `RoleLanding` (la racine `/` d'`App.tsx`) et la cible
 * post-connexion (`publicOnlyRedirects` → `resolveLoginTarget`).
 */
export const TODAY_PATH = '/accueil'

/**
 * Recette 3B — repli quand ni « Aujourd'hui » ni « Analyse » ne sont permis
 * (les deux lisent `canAccessStats` depuis L-NAV-9) : la route `/contacts` est
 * ouverte (catalogue `access/screens.ts`, `route: 'open'`), elle n'aboutit
 * jamais à « Accès refusé ».
 */
export const FALLBACK_HOME = '/contacts'

/**
 * @param canSeeStats `hasPermission('canAccessStats')` (compat + compte système
 *   inclus) — lu par `/accueil` ET `/analytics` (catalogue L-NAV-9). Faux ⇒
 *   repli `FALLBACK_HOME` au lieu d'un atterrissage sur un refus.
 */
export function roleHome(role: string | undefined, canCall: boolean, canSeeStats = true): string {
  if (role === 'AGENT' && canCall) return '/v2/softphone'
  if (!canSeeStats) return FALLBACK_HOME
  if (role === 'ADMIN') return TODAY_PATH
  return '/analytics'
}

/**
 * Cible post-connexion PAR DÉFAUT (sans `state.from` ni mémoire d'onglet) :
 * l'admin va DROIT sur `/accueil` (pas de détour par `/` puis `RoleLanding`) ;
 * tout autre rôle garde la racine `/`, qui aiguille comme avant (agent
 * inchangé : `/` → `/v2/softphone`).
 */
export function loginHomeFor(role: string | undefined, canSeeStats = true): string {
  // Recette 3B : un ADMIN sans `canAccessStats` passe par « / » (RoleLanding ⇒ repli).
  return role === 'ADMIN' && canSeeStats ? TODAY_PATH : '/'
}
